import Vue from 'vue';
import router from '../src/routes/router.js';
import App from './App.vue';
import { GridColumn } from './components/dataTable.vue';
import { toast } from './js/toast';

Vue.component('grid-column', GridColumn);
Vue.prototype.$toast = toast;

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(tag => document.head.appendChild(tag));

  next();
});

Vue.config.productionTip = false;

new Vue({
  data: {
    user: null,
    menuOptions: [],
    company: {},
    selectedTheme: null,
    jwtLoaded: false
  },
  router,
  render: h => h(App),
}).$mount('#app')
